<!--
 * @Author: your name
 * @Date: 2021-03-08 13:36:11
 * @LastEditTime: 2021-05-20 17:28:07
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /youhuaguo-ui/src/components/common/approveMember.vue
-->
<template>

  <div>
    <div class="filter-wrap" :gutter="20" v-if="show_box">
      <div v-if="this.approveObj.directorNameList" :span="6">直属主管审批人：{{this.approveObj.directorName}}</div>
      <div v-if="this.approveObj.chiefNameList" :span="6">业务总监审批人：{{this.approveObj.chiefName}}</div>
      <div v-if="this.approveObj.treasurerNameList" :span="6">财务审批人：{{this.approveObj.treasurerName}}</div>
      <div v-if="this.approveObj.cashierNameList" :span="6">出纳审批人：{{this.approveObj.cashierName}}</div>
    </div>

    <div class="approve-list mb-10" v-if="
        this.approveObj.directorNameList 
        || this.approveObj.chiefNameList
        || this.approveObj.treasurerNameList
        || this.approveObj.cashierNameList">
      <span>(</span>
      <ul>
        <li v-if="this.approveObj.directorNameList">
          直属主管可审批人：<span v-for="(item, index) in this.approveObj.directorNameList" :key="index">{{item}}； </span>
        </li>
        <li v-if="this.approveObj.chiefNameList">
          业务总监可审批人：<span v-for="(item, index) in this.approveObj.chiefNameList" :key="index">{{item}}；</span> <span v-if="!this.approveObj.treasurerNameList">)</span>
        </li>
        <li v-if="this.approveObj.treasurerNameList">
          财务可审批人：<span v-for="(item, index) in this.approveObj.treasurerNameList" :key="index">{{item}}； </span>
        </li>
        <li v-if="this.approveObj.cashierNameList">出纳可审批人：<span v-for="(item, index) in this.approveObj.cashierNameList" :key="index">{{item}}； </span>)</li>
      </ul>
    </div>
    <div>
      <div v-if="auditStatus">审批状态：{{ approveConfig.getAppointed("statusTwo", auditStatus, "") }}</div>
    </div>
  </div>
</template>

<script>
import { approveConfig } from "@/const/config/approve";
export default {
  props: ["approveObj", "auditStatus"],
  created() {
    console.log(this.approveObj);
  },
  data() {
    return {
      approveConfig,
      show_box:true,  //勿删除  其他地方使用隐藏  默认显示
      directorName: "", //直属主管
      chiefName: "", //业务总监
      treasurerName: "", //财务
      cashierName: "", // 出纳
      directorNameList: [], //直属主管列表
      chiefNameList: [], //业务总监列表
      treasurerNameList: [], //财务列表
      cashierNameList: [], //出纳列表
    };
  },
};
</script>

<style scoped lang="scss">
.approve-member {
  display: flex;
  color: #606266;
  margin-bottom: 10px;
  li {
    margin-right: 40px;
  }
}
.approve-list {
  display: inline-flex;
}
.mb-10 {
  margin-bottom: 10px;
}
</style>